// complimentary products
document.addEventListener('DOMContentLoaded', () => {
  console.log("111");

  const checkboxes = document.querySelectorAll('.cp-checkbox');
  const form = document.querySelector('product-form.product__block.product__form__wrapper form');

  console.log("form", form, checkboxes);

  if (!checkboxes.length || !form) return;

  let isSubmitting = false;

  form.addEventListener('submit', async (e) => {
    console.log("2222");

    if (isSubmitting) {
      e.preventDefault();
      return;
    }

    // const button = e.submitter;
    // const isAddToCart = button?.name === 'add';

    // if (!isAddToCart) return;

    const selectedItems = [];

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked && checkbox.value) {
        selectedItems.push({
          id: parseInt(checkbox.value, 10),
          quantity: 1
        });
      }
    });

    // If no complimentary products are selected,
    // let the theme handle the normal add-to-cart.
    if (selectedItems.length === 0) return;

    e.preventDefault();

    // const mainVariantInput = form.querySelector('[name="id"]');
    // if (!mainVariantInput?.value) return;

    // const mainQtyInput =
    //   form.querySelector('input[name="quantity"]') ||
    //   form.querySelector('quantity-input input') ||
    //   form.querySelector('.quantity__input');

    // const mainQty = Math.max(
    //   parseInt(mainQtyInput?.value || "1", 10) || 1,
    //   1
    // );

    // // Add main product first
    // selectedItems.unshift({
    //   id: parseInt(mainVariantInput.value, 10),
    //   quantity: mainQty
    // });

    isSubmitting = true;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: selectedItems
        })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error(data);
        isSubmitting = false;
        return;
      }

      console.log("Added to cart:", data);

      document.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      document.dispatchEvent(
        new CustomEvent('theme:cart:refresh', { bubbles: true })
      );

      // Open drawer if your theme supports it
      document.dispatchEvent(
        new CustomEvent('cart:open', { bubbles: true })
      );

    } catch (err) {
      console.error(err);
    } finally {
      isSubmitting = false;
    }
  });
});
// slider
const slider = document.querySelector('.cp-products');

if (slider) {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('grabbing');

    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('grabbing');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('grabbing');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;
    slider.scrollLeft = scrollLeft - walk;
  });
}